import { render } from "./CarsTable.vue?vue&type=template&id=044d463e"
import script from "./CarsTable.vue?vue&type=script&lang=js"
export * from "./CarsTable.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./CarsTable.vue?vue&type=style&index=0&id=044d463e&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script